import React, { useState, useEffect } from 'react';
import { clientLogger } from '../utils/logger';
import { fetchOrganizations } from '../utils/apiUtils';

const VisibilityTestHarness = () => {
    const [organization, setOrganization] = useState(null);
    const [coreResponses, setCoreResponses] = useState([]);
    const [features, setFeatures] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Load initial organization data
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                
                // Use the utility function to fetch organizations
                const orgs = await fetchOrganizations();
                setOrganization(orgs[0]);
                
                setLoading(false);
            } catch (error) {
                clientLogger.error('Error fetching data:', error);
                setError(error.message);
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // Load responses and features when org is set
    useEffect(() => {
        const loadOrgData = async () => {
            if (!organization?.id) return;
            
            setLoading(true);
            try {
                // Load core responses
                const responsesRes = await fetch(`/api/core-questions/responses/${organization.id}`, {
                    credentials: 'include'
                });
                const responses = await responsesRes.json();
                setCoreResponses(responses);

                // Load features
                const featuresRes = await fetch(`/api/features/${organization.id}`, {
                    credentials: 'include'
                });
                const features = await featuresRes.json();
                setFeatures(features);

                setLoading(false);
            } catch (err) {
                console.error('Error loading organization data:', err);
                setError(err.message);
                setLoading(false);
            }
        };

        loadOrgData();
    }, [organization]);

    if (error) {
        return <div style={{ padding: '20px', color: 'red' }}>Error: {error}</div>;
    }

    if (loading) {
        return <div style={{ padding: '20px' }}>Loading data...</div>;
    }

    // Group features by section
    const groupedFeatures = {};
    features.forEach(feature => {
        const section = feature.section || 'Uncategorized';
        if (!groupedFeatures[section]) {
            groupedFeatures[section] = [];
        }
        groupedFeatures[section].push(feature);
    });

    return (
        <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
            <h1 style={{ marginBottom: '20px', fontSize: '24px' }}>Feature Visibility Test Harness</h1>
            
            {/* Organization Info */}
            <div style={{ marginBottom: '20px', padding: '10px', border: '1px solid #ccc' }}>
                <h2 style={{ marginBottom: '10px', fontSize: '18px' }}>Organization</h2>
                <div>{organization?.name || 'No organization selected'}</div>
            </div>

            <div style={{ display: 'flex', gap: '20px' }}>
                {/* Core Question Responses */}
                <div style={{ flex: 1, border: '1px solid #ccc', padding: '20px' }}>
                    <h2 style={{ marginBottom: '15px', fontSize: '18px' }}>Core Question Responses</h2>
                    {coreResponses.map((response) => (
                        <div key={response.id} style={{ marginBottom: '15px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
                            <div style={{ fontWeight: 'bold' }}>Question ID: {response.question_id}</div>
                            <div style={{ marginTop: '5px', color: '#666' }}>
                                Response: {
                                    typeof response.response_value === 'object' 
                                        ? JSON.stringify(response.response_value, null, 2)
                                        : response.response_value
                                }
                            </div>
                        </div>
                    ))}
                </div>

                {/* Feature Structure */}
                <div style={{ flex: 1, border: '1px solid #ccc', padding: '20px' }}>
                    <h2 style={{ marginBottom: '15px', fontSize: '18px' }}>Features Structure</h2>
                    {Object.entries(groupedFeatures).map(([section, sectionFeatures]) => (
                        <div key={section} style={{ marginBottom: '20px' }}>
                            <h3 style={{ marginBottom: '10px', fontSize: '16px' }}>{section}</h3>
                            <ul style={{ marginLeft: '20px', listStyle: 'none' }}>
                                {sectionFeatures.map(feature => (
                                    <li key={feature.reference} style={{ marginBottom: '5px', fontSize: '12px' }}>
                                        {feature.name} ({feature.reference})
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default VisibilityTestHarness;